"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addInsuranceForEmiratesId = addInsuranceForEmiratesId;
exports.addNewInsurance = addNewInsurance;
exports.callTeleconsultService = callTeleconsultService;
exports.cancelAppointment = cancelAppointment;
exports.cdmServices = cdmServices;
exports.checkCdmAppointmentEligibility = checkCdmAppointmentEligibility;
exports.createAppointment = createAppointment;
exports.default = appointmentApiWatcher;
exports.deleteInsurance = deleteInsurance;
exports.getAppointmentDetails = getAppointmentDetails;
exports.getAppointmentDetailsWithLatLong = getAppointmentDetailsWithLatLong;
exports.getAppointmentDetailsWithRxPreorder = getAppointmentDetailsWithRxPreorder;
exports.getAppointments = getAppointments;
exports.getAvailableSlots = getAvailableSlots;
exports.getAvailableSlotsCount = getAvailableSlotsCount;
exports.getCDMAppointmentDetails = getCDMAppointmentDetails;
exports.getFacilityInsuranceMapping = getFacilityInsuranceMapping;
exports.getInsuranceProviders = getInsuranceProviders;
exports.getPatientsAllInsurance = getPatientsAllInsurance;
exports.getPaymentOrderstatus = getPaymentOrderstatus;
exports.getPrescriptionById = getPrescriptionById;
exports.getShadowAppointmentDetails = getShadowAppointmentDetails;
exports.initiatePayment = initiatePayment;
exports.makeItDefaultInsurance = makeItDefaultInsurance;
exports.postShadowAppointmentDetails = postShadowAppointmentDetails;
exports.preBookingAppointmentCharges = preBookingAppointmentCharges;
exports.reasonCancelAppointment = reasonCancelAppointment;
exports.rebookAndRefundAppointmentSaga = rebookAndRefundAppointmentSaga;
exports.rescheduleAppointment = rescheduleAppointment;
exports.updateAppointmentStatus = updateAppointmentStatus;
exports.updateInsurance = updateInsurance;
var _effects = require("redux-saga/effects");
var _sagas = require("../../../astercore/auth/login/redux/sagas");
var _utils = require("../../../common/utils/utils");
var api = _interopRequireWildcard(require("../api/api"));
var actions = _interopRequireWildcard(require("./actions"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/*
    Request Params
    onSuccess: success callback
    queryParam: search query parameter
*/
function* createAppointment(requestParams) {
  try {
    yield (0, _effects.put)(actions.CREATE_APPOINTMENT_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.createAppointment, requestParams, tokenData);
    yield (0, _effects.put)(actions.CREATE_APPOINTMENT_API.success(mainResponse));
    requestParams.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.CREATE_APPOINTMENT_API.failure(err));
    requestParams.data.onFailure(err);
  }
}
function* rescheduleAppointment(requestParams) {
  try {
    yield (0, _effects.put)(actions.RESCHEDULE_APPOINTMENT_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.rescheduleAppointment, requestParams, tokenData);
    yield (0, _effects.put)(actions.RESCHEDULE_APPOINTMENT_API.success(mainResponse));
    requestParams.data.onSuccess(mainResponse);
    return mainResponse.data;
  } catch (err) {
    yield (0, _effects.put)(actions.RESCHEDULE_APPOINTMENT_API.failure(err));
    requestParams.data.onFailure(err);
  }
}
function* reasonCancelAppointment(requestParams) {
  try {
    yield (0, _effects.put)(actions.REASON_CANCEL_APPOINTMENT_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.reasonCancelAppointment, tokenData);
    yield (0, _effects.put)(actions.REASON_CANCEL_APPOINTMENT_API.success(mainResponse));
    requestParams.data.onSuccess(mainResponse);
    return mainResponse.data;
  } catch (err) {
    yield (0, _effects.put)(actions.REASON_CANCEL_APPOINTMENT_API.failure(err));
    requestParams.data.onFailure(err);
  }
}
function* cancelAppointment(requestParams) {
  try {
    yield (0, _effects.put)(actions.CANCEL_APPOINTMENT_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.cancelAppointment, requestParams, tokenData);
    yield (0, _effects.put)(actions.CANCEL_APPOINTMENT_API.success(mainResponse));
    requestParams.data.onSuccess(mainResponse);
    return mainResponse.data;
  } catch (err) {
    yield (0, _effects.put)(actions.CANCEL_APPOINTMENT_API.failure(err));
    requestParams.data.onFailure(err);
  }
}
function* getAvailableSlots(requestParams) {
  try {
    const {
      onSuccess
    } = requestParams.data;
    yield (0, _effects.put)(actions.GET_AVAILABLE_SLOTS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getAvailableSlots, requestParams.data.requestParams, tokenData);
    yield (0, _effects.put)(actions.GET_AVAILABLE_SLOTS_API.success(mainResponse));
    if (onSuccess && mainResponse && mainResponse) {
      onSuccess(mainResponse);
    }
  } catch (err) {
    yield (0, _effects.put)(actions.GET_AVAILABLE_SLOTS_API.failure(err));
    requestParams.data.onFailure(err);
  }
}

/*
    Request Params
    onSuccess: success callback
    onFailure: failure callback
    requestParams: {id, appointmentType }
*/
function* getAppointments(request) {
  try {
    const {
      onSuccess,
      requestParams,
      showLoader = true
    } = request.data;
    if (_utils.isMobile && showLoader || !_utils.isMobile) {
      yield (0, _effects.put)(actions.GET_APPOINTMENTS_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getAppointments, requestParams, tokenData);
    yield (0, _effects.put)(actions.GET_APPOINTMENTS_API.success(mainResponse));
    if (onSuccess) {
      var _mainResponse$entry;
      onSuccess((_mainResponse$entry = mainResponse.entry) !== null && _mainResponse$entry !== void 0 ? _mainResponse$entry : []);
    }
    return mainResponse.data;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_APPOINTMENTS_API.failure(err));
    if (request.data && request.data.onFailure) {
      request.data.onFailure(err);
    }
  }
}

/*
    Request Params
    onSuccess: success callback
    onFailure: failure callback
    requestParams: appointmentid
*/
function* getAppointmentDetails(request) {
  try {
    const {
      onSuccess,
      requestParams,
      showLoader = true
    } = request.data;
    if (_utils.isMobile && showLoader || !_utils.isMobile) {
      yield (0, _effects.put)(actions.GET_APPOINTMENT_DETAILS_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getAppointmentDetails, requestParams, tokenData);
    yield (0, _effects.put)(actions.GET_APPOINTMENT_DETAILS_API.success(mainResponse));
    if (onSuccess) {
      onSuccess(mainResponse);
    }
    if (!(0, _utils.isMobile)()) {
      return mainResponse.data;
    }
  } catch (err) {
    var _request$data;
    yield (0, _effects.put)(actions.GET_APPOINTMENT_DETAILS_API.failure(err));
    if (request !== null && request !== void 0 && (_request$data = request.data) !== null && _request$data !== void 0 && _request$data.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* getShadowAppointmentDetails(request) {
  try {
    var _request$data2;
    yield (0, _effects.put)(actions.GET_SHADOW_APPOINTMENT_DETAILS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getShadowAppointmentDetails, request.data.requestParams, tokenData);
    yield (0, _effects.put)(actions.GET_SHADOW_APPOINTMENT_DETAILS_API.success(mainResponse));
    if (request !== null && request !== void 0 && (_request$data2 = request.data) !== null && _request$data2 !== void 0 && _request$data2.onSuccess) {
      request.data.onSuccess(mainResponse);
    }
  } catch (err) {
    var _request$data3;
    yield (0, _effects.put)(actions.GET_SHADOW_APPOINTMENT_DETAILS_API.failure(err));
    if (request !== null && request !== void 0 && (_request$data3 = request.data) !== null && _request$data3 !== void 0 && _request$data3.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* postShadowAppointmentDetails(request) {
  try {
    var _request$data4;
    yield (0, _effects.put)(actions.POST_SHADOW_APPOINTMENT_DETAILS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.postShadowAppointmentDetails, request.data.requestParams, tokenData);
    yield (0, _effects.put)(actions.POST_SHADOW_APPOINTMENT_DETAILS_API.success(mainResponse));
    if (request !== null && request !== void 0 && (_request$data4 = request.data) !== null && _request$data4 !== void 0 && _request$data4.onSuccess) {
      request.data.onSuccess(mainResponse);
    }
  } catch (err) {
    var _request$data5;
    yield (0, _effects.put)(actions.POST_SHADOW_APPOINTMENT_DETAILS_API.failure(err));
    if (request !== null && request !== void 0 && (_request$data5 = request.data) !== null && _request$data5 !== void 0 && _request$data5.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* updateAppointmentStatus(requestParams) {
  try {
    yield (0, _effects.put)(actions.UPDATE_APPOINTMENT_STATUS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.updateAppointmentStatus, requestParams, tokenData);
    yield (0, _effects.put)(actions.UPDATE_APPOINTMENT_STATUS_API.success(mainResponse));
    requestParams.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.UPDATE_APPOINTMENT_STATUS_API.failure(err));
    requestParams.data.onFailure(err);
  }
}
function* getAvailableSlotsCount(request) {
  try {
    yield (0, _effects.put)(actions.TELE_SEARCH_SLOTS_COUNT_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getAvailableSlotsCount, request.data.requestParams, tokenData);
    yield (0, _effects.put)(actions.TELE_SEARCH_SLOTS_COUNT_API.success(mainResponse));
    if (request && request.data && request.data.onSuccess) {
      request.data.onSuccess(mainResponse !== null && mainResponse !== void 0 ? mainResponse : []);
    }
  } catch (err) {
    yield (0, _effects.put)(actions.TELE_SEARCH_SLOTS_COUNT_API.failure(err));
    if (request.data && request.data.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* initiatePayment(requestParams) {
  try {
    yield (0, _effects.put)(actions.INITIATE_PAYMENT_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.initiatePayment, requestParams, tokenData);
    yield (0, _effects.put)(actions.INITIATE_PAYMENT_API.success(mainResponse));
    requestParams.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.INITIATE_PAYMENT_API.failure(err));
    requestParams.data.onFailure(err);
  }
}
function* getPatientsAllInsurance(request) {
  try {
    const {
      requestParam,
      showLoader = true,
      onSuccess,
      enableCache
    } = request.data;
    if (_utils.isMobile && showLoader || !_utils.isMobile) {
      yield (0, _effects.put)(actions.GET_PATIENTS_ALL_INSURANCE_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getAllInsurance, requestParam, tokenData, enableCache);
    yield (0, _effects.put)(actions.GET_PATIENTS_ALL_INSURANCE_API.success(mainResponse));
    if (onSuccess) {
      request.data.onSuccess(mainResponse);
    }
  } catch (err) {
    yield (0, _effects.put)(actions.GET_PATIENTS_ALL_INSURANCE_API.failure(err));
    if (request.data.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* getInsuranceProviders(request) {
  try {
    const {
      onSuccess
    } = request.data;
    yield (0, _effects.put)(actions.GET_INSURANCE_PROVIDERS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getInsuranceProviders, tokenData);
    yield (0, _effects.put)(actions.GET_INSURANCE_PROVIDERS_API.success({}));
    if (onSuccess && mainResponse) {
      onSuccess(mainResponse.data);
    }
  } catch (err) {
    yield (0, _effects.put)(actions.GET_INSURANCE_PROVIDERS_API.failure(err));
    if (request.data.onFailure) {
      request.data.onFailure(err);
    }
  }
}

/*
    Request Params
    onSuccess: success callback
    onFailure: failure callback
    requestParams: { patientId, insuranceId, insuranceName }
*/
function* addNewInsurance(request) {
  try {
    const {
      onSuccess,
      requestParams
    } = request.data;
    yield (0, _effects.put)(actions.ADD_NEW_INSURANCE_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.addNewInsurance, requestParams, tokenData);
    yield (0, _effects.put)(actions.ADD_NEW_INSURANCE_API.success(mainResponse));
    if (onSuccess && mainResponse) {
      onSuccess(mainResponse);
    }
  } catch (err) {
    yield (0, _effects.put)(actions.ADD_NEW_INSURANCE_API.failure(err));
    if (request.data && request.data.onFailure) {
      request.data.onFailure(err);
    }
  }
}
/*
    Request Params
    onSuccess: success callback
    onFailure: failure callback
    requestParams: {
      appointmentId: appointmentId,
      payment: {
        action: 'SALE',
        amount: {
          currencyCode: 'AED',
          value: fees
        },
        language: 'en',
        emailAddress: '',
        merchantAttributes: {
          redirectUrl: 'https://vcp-dev-api.1aster.com/' + 'confirmappointment',
          cancelUrl: 'https://vcp-dev-api.1aster.com/' + 'home',
          skipConfirmationPage: true
        }
     }
*/

function* addInsuranceForEmiratesId(request) {
  try {
    const {
      onSuccess,
      requestParams
    } = request.data;
    yield (0, _effects.put)(actions.ADD_INSURANCE_EMIRATES_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.addInsuranceForEmiratesId, requestParams, tokenData);
    yield (0, _effects.put)(actions.ADD_INSURANCE_EMIRATES_API.success(mainResponse));
    if (onSuccess && mainResponse) {
      onSuccess(mainResponse);
    }
  } catch (err) {
    yield (0, _effects.put)(actions.ADD_INSURANCE_EMIRATES_API.failure(err));
    if (request.data && request.data.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* getPaymentOrderstatus(params) {
  try {
    yield (0, _effects.put)(actions.GET_PAYMENT_STATUS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getPaymentOrderstatus, params, tokenData);
    yield (0, _effects.put)(actions.GET_PAYMENT_STATUS_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_PAYMENT_STATUS_API.failure(err));
    params.data.onFailure(err);
  }
}
function* callTeleconsultService(requestParams) {
  const {
    data
  } = requestParams;
  try {
    yield (0, _effects.put)(actions.CALL_TELECONSULT_SERVICE_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.callTeleconsultService, data, tokenData);
    yield (0, _effects.put)(actions.CALL_TELECONSULT_SERVICE_API.success(mainResponse));
    requestParams.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.CALL_TELECONSULT_SERVICE_API.failure(err));
    requestParams.data.onFailure(err);
  }
}
/*
    Request Params
    onSuccess: success callback
    onFailure: failure callback
    params: prescription encounterId
*/
function* getPrescriptionById(request) {
  try {
    const {
      onSuccess,
      params,
      showLoader = true
    } = request.data;
    if (_utils.isMobile && showLoader || !_utils.isMobile) {
      yield (0, _effects.put)(actions.GET_PRESCRIPTION_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getPrescriptionById, params, tokenData);
    yield (0, _effects.put)(actions.GET_PRESCRIPTION_API.success(mainResponse));
    if (onSuccess) {
      onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    var _request$data6;
    yield (0, _effects.put)(actions.GET_PRESCRIPTION_API.failure(err));
    if (request !== null && request !== void 0 && (_request$data6 = request.data) !== null && _request$data6 !== void 0 && _request$data6.onFailure) {
      var _request$data7;
      request === null || request === void 0 || (_request$data7 = request.data) === null || _request$data7 === void 0 || _request$data7.onFailure(err);
    }
  }
}

/*
    Request Params
    onSuccess: success callback
    onFailure: failure callback
    requestParams: appointmentid
*/
function* getAppointmentDetailsWithLatLong(request) {
  try {
    const {
      onSuccess,
      requestParams,
      lat,
      long
    } = request.data;
    yield (0, _effects.put)(actions.GET_APPOINTMENT_DETAILS_WITH_LAT_LONG_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getAppointmentDetailsWithLatLong, requestParams, lat, long, tokenData);
    yield (0, _effects.put)(actions.GET_APPOINTMENT_DETAILS_WITH_LAT_LONG_API.success(mainResponse));
    if (onSuccess) {
      onSuccess(mainResponse);
    }
    return mainResponse.data;
  } catch (err) {
    var _request$data8;
    yield (0, _effects.put)(actions.GET_APPOINTMENT_DETAILS_WITH_LAT_LONG_API.failure(err));
    if (request !== null && request !== void 0 && (_request$data8 = request.data) !== null && _request$data8 !== void 0 && _request$data8.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* getAppointmentDetailsWithRxPreorder(request) {
  const {
    onSuccess,
    requestParams,
    onFailure
  } = request.data;
  try {
    if (!_utils.isMobile) {
      yield (0, _effects.put)(actions.GET_APPOINTMENT_DETAILS_WITH_RX_PRE_ORDER_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getAppointmentDetailsWithRxPreorder, requestParams, tokenData);
    yield (0, _effects.put)(actions.GET_APPOINTMENT_DETAILS_WITH_RX_PRE_ORDER_API.success(mainResponse));
    if (onSuccess) {
      onSuccess(mainResponse);
    }
    return mainResponse.data;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_APPOINTMENT_DETAILS_WITH_RX_PRE_ORDER_API.failure(err));
    if (onFailure) {
      onFailure(err);
    }
  }
}
function* makeItDefaultInsurance(request) {
  try {
    const {
      onSuccess,
      requestParams
    } = request.data;
    yield (0, _effects.put)(actions.MAKE_IT_DEFAULT_INSURANCE_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.makeItDefaultInsurance, requestParams, tokenData);
    yield (0, _effects.put)(actions.MAKE_IT_DEFAULT_INSURANCE_API.success(mainResponse));
    if (onSuccess && mainResponse) {
      onSuccess(mainResponse);
    }
  } catch (err) {
    yield (0, _effects.put)(actions.MAKE_IT_DEFAULT_INSURANCE_API.failure(err));
    if (request.data && request.data.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* preBookingAppointmentCharges(requestParams) {
  const {
    showLoader = true
  } = requestParams === null || requestParams === void 0 ? void 0 : requestParams.data;
  try {
    if (showLoader) {
      yield (0, _effects.put)(actions.CREATE_APPOINTMENT_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getPreBookingAppointmentCharges, requestParams, tokenData);
    yield (0, _effects.put)(actions.CREATE_APPOINTMENT_API.success(mainResponse));
    requestParams.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.CREATE_APPOINTMENT_API.failure(err));
    requestParams.data.onFailure(err);
  }
}
function* updateInsurance(requestParams) {
  try {
    var _requestParams$data;
    yield (0, _effects.put)(actions.UPDATE_INSURANCE_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.updateInsurance, requestParams === null || requestParams === void 0 || (_requestParams$data = requestParams.data) === null || _requestParams$data === void 0 ? void 0 : _requestParams$data.params, tokenData);
    yield (0, _effects.put)(actions.UPDATE_INSURANCE_API.success(mainResponse));
    requestParams.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.UPDATE_INSURANCE_API.failure(err));
    requestParams.data.onFailure(err);
  }
}
function* deleteInsurance(requestParams) {
  try {
    var _requestParams$data2;
    yield (0, _effects.put)(actions.DELETE_INSURANCE_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.deleteInsurance, requestParams === null || requestParams === void 0 || (_requestParams$data2 = requestParams.data) === null || _requestParams$data2 === void 0 ? void 0 : _requestParams$data2.params, tokenData);
    yield (0, _effects.put)(actions.DELETE_INSURANCE_API.success(mainResponse));
    requestParams.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.DELETE_INSURANCE_API.failure(err));
    requestParams.data.onFailure(err);
  }
}
function* getFacilityInsuranceMapping(requestParams) {
  try {
    yield (0, _effects.put)(actions.GET_FACILITY_INSURANCE_MAPPING_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getFacilityAndInsuranceMapping, requestParams.data.params, tokenData);
    yield (0, _effects.put)(actions.GET_FACILITY_INSURANCE_MAPPING_API.success(mainResponse));
    requestParams.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_FACILITY_INSURANCE_MAPPING_API.failure(err));
    requestParams.data.onFailure(err);
  }
}
function* rebookAndRefundAppointmentSaga(requestParams) {
  try {
    yield (0, _effects.put)(actions.REBOOK_AND_REFUND_APPOINTMENT_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.rebookAndRefundAppointment, requestParams, tokenData);
    yield (0, _effects.put)(actions.REBOOK_AND_REFUND_APPOINTMENT_API.success(mainResponse));
    requestParams.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.REBOOK_AND_REFUND_APPOINTMENT_API.failure(err));
    requestParams.data.onFailure(err);
  }
}
function* cdmServices(requestParams) {
  try {
    // yield put(actions.CDM_SERVICES_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.cdmServices, requestParams.data.params, tokenData);
    yield (0, _effects.put)(actions.CDM_SERVICES_API.success(mainResponse));
    requestParams.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.CDM_SERVICES_API.failure(err));
    requestParams.data.onFailure(err);
  }
}
function* checkCdmAppointmentEligibility(requestParams) {
  try {
    yield (0, _effects.put)(actions.CHECK_CDM_APPOINTMENT_ELIGIBILITY_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.checkCDMAppointmentEligibility, requestParams.data.params, tokenData);
    yield (0, _effects.put)(actions.CHECK_CDM_APPOINTMENT_ELIGIBILITY_API.success(mainResponse));
    requestParams.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.CHECK_CDM_APPOINTMENT_ELIGIBILITY_API.failure(err));
    requestParams.data.onFailure(err);
  }
}
function* getCDMAppointmentDetails(requestParams) {
  try {
    // yield put(actions.GET_CDM_APPOINTMENT_DETAILS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getCDMAppointmentDetails, requestParams.data.params, tokenData);
    yield (0, _effects.put)(actions.GET_CDM_APPOINTMENT_DETAILS_API.success(mainResponse));
    requestParams.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_CDM_APPOINTMENT_DETAILS_API.failure(err));
    requestParams.data.onFailure(err);
  }
}
function* appointmentApiWatcher() {
  yield (0, _effects.takeLatest)(actions.CREATE_APPOINTMENT, createAppointment);
  yield (0, _effects.takeLatest)(actions.RESCHEDULE_APPOINTMENT, rescheduleAppointment);
  yield (0, _effects.takeLatest)(actions.REASON_CANCEL_APPOINTMENT, reasonCancelAppointment);
  yield (0, _effects.takeLatest)(actions.CANCEL_APPOINTMENT, cancelAppointment);
  yield (0, _effects.takeLatest)(actions.GET_APPOINTMENTS, getAppointments);
  yield (0, _effects.takeEvery)(actions.GET_APPOINTMENT_DETAILS, getAppointmentDetails);
  yield (0, _effects.takeLatest)(actions.GET_SHADOW_APPOINTMENT_DETAILS, getShadowAppointmentDetails);
  yield (0, _effects.takeLatest)(actions.POST_SHADOW_APPOINTMENT_DETAILS, postShadowAppointmentDetails);
  yield (0, _effects.takeLatest)(actions.UPDATE_APPOINTMENT_STATUS, updateAppointmentStatus);
  yield (0, _effects.takeLatest)(actions.GET_AVAILABLE_SLOTS, getAvailableSlots);
  yield (0, _effects.takeLatest)(actions.TELE_SEARCH_SLOTS_COUNT, getAvailableSlotsCount);
  yield (0, _effects.takeLatest)(actions.INITIATE_PAYMENT, initiatePayment);
  yield (0, _effects.takeLatest)(actions.GET_PATIENTS_ALL_INSURANCE, getPatientsAllInsurance);
  yield (0, _effects.takeLatest)(actions.GET_INSURANCE_PROVIDERS, getInsuranceProviders);
  yield (0, _effects.takeLatest)(actions.ADD_NEW_INSURANCE, addNewInsurance);
  yield (0, _effects.takeLatest)(actions.ADD_INSURANCE_EMIRATES, addInsuranceForEmiratesId);
  yield (0, _effects.takeLatest)(actions.GET_PAYMENT_STATUS, getPaymentOrderstatus);
  yield (0, _effects.takeLatest)(actions.CALL_TELECONSULT_SERVICE, callTeleconsultService);
  yield (0, _effects.takeLatest)(actions.GET_PRESCRIPTION, getPrescriptionById);
  yield (0, _effects.takeLatest)(actions.GET_APPOINTMENT_DETAILS_WITH_LAT_LONG, getAppointmentDetailsWithLatLong);
  yield (0, _effects.takeLatest)(actions.GET_APPOINTMENT_DETAILS_WITH_RX_PRE_ORDER, getAppointmentDetailsWithRxPreorder);
  yield (0, _effects.takeLatest)(actions.MAKE_IT_DEFAULT_INSURANCE, makeItDefaultInsurance);
  yield (0, _effects.takeLatest)(actions.GET_PRE_BOOK_APPOINTMENT_CHARGES, preBookingAppointmentCharges);
  yield (0, _effects.takeLatest)(actions.UPDATE_INSURANCE, updateInsurance);
  yield (0, _effects.takeLatest)(actions.DELETE_INSURANCE, deleteInsurance);
  yield (0, _effects.takeLatest)(actions.GET_FACILITY_INSURANCE_MAPPING, getFacilityInsuranceMapping);
  yield (0, _effects.takeLatest)(actions.REBOOK_AND_REFUND_APPOINTMENT, rebookAndRefundAppointmentSaga);
  yield (0, _effects.takeLatest)(actions.CDM_SERVICES, cdmServices);
  yield (0, _effects.takeLatest)(actions.CHECK_CDM_APPOINTMENT_ELIGIBILITY, checkCdmAppointmentEligibility);
  yield (0, _effects.takeLatest)(actions.GET_CDM_APPOINTMENT_DETAILS, getCDMAppointmentDetails);
}